let swiper = new Swiper(".js-photos-slider-new-thumbs", {
    spaceBetween: 20,
    slidesPerView: 3,
    freeMode: false,
    currentClass: 'active-thumb',
    watchSlidesProgress: true,
    breakpoints: {
        1180: {
            freeMode: true,
            spaceBetween: 10,
            slidesPerView: 'auto'
        }
    }
});

let swiper2 = new Swiper(".js-photos-slider-new", {
    spaceBetween: 10,
    slidesPerView: 1,
    freeMode: false,
    navigation: {
        nextEl: ".js-slider-next-new",
        prevEl: ".js-slider-prev-new",
    },
    thumbs: {
        swiper: swiper,
    },
    breakpoints: {
        1180: {
            spaceBetween: 10,
            slidesPerView: 1,
            freeMode: true,
        }
    }
});

let swiper3 = new Swiper(".js-photos-slider-vacancy", {
    spaceBetween: 50,
    slidesPerView: 'auto',
    centeredSlides: false,
    loop: true,
    breakpoints: {
        1024: {
            spaceBetween: 20,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
        }
    },
    on: {
        init: function (e) {
            let $slide = $(e.el).find('.js-slider-item-new:nth-child(2n)');
            $slide.addClass('big');
        },
    },
});

let swiper4 = new Swiper(".js-slider-case", {
    spaceBetween: 50,
    slidesPerView: 'auto',
    centeredSlides: false,
    loop: true,
    breakpoints: {
        1024: {
            spaceBetween: 20,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
        }
    }
});

$(window).on('load resize', function() {
    if($(window).width() < 769 && swiper !== undefined) {
        swiper.destroy(true, true);
    }
});
